<div class="layout-col full">
  <app-package-detail class="flex" [package]="pkg$ | async" (close)="close()"> </app-package-detail>
</div>
